import React, { useState } from 'react';

import { MindMapCourse } from './MindMapCourse';
import { useMindMap } from '../useMindMap';
import { notify } from '../../../app';

// TODO(Kuriy): it's a temporary solution for the test purpose
export const TestMindMap: React.FC = () => {
  const { updateMindMap, loading, mindMap } = useMindMap('10');
  const [jsonInput, setJsonInput] = useState('');
  const [fullScreenMode, setFullScreenMode] = useState(false);

  const handleGenerateGraph = () => {
    try {
      const parsedData = JSON.parse(jsonInput);
      updateMindMap(parsedData);
    } catch (error) {
      notify.error('Invalid JSON input');
    }
  };

  return (
    <div className="flex flex-row items-start justify-between p-md bg-gray-100 min-h-screen">
      <div className="w-1/3 flex flex-col items-center p-md border-r border-gray-300">
        <button
          className="mt-xs px-md py-xs bg-blue-500 text-white rounded-md hover:bg-blue-600 transition"
          onClick={handleGenerateGraph}
          disabled={loading}
        >
          {loading ? 'Loading...' : 'Generate Graph'}
        </button>
        <h1 className="text-medium font-bold mb-xs">JSON to Graph Generator</h1>

        <textarea
          placeholder="Paste your JSON data here..."
          value={jsonInput}
          onChange={e => setJsonInput(e.target.value)}
          className="w-full h-[50rem] border border-gray-300 rounded-md p-sm shadow-md resize-none"
        />
      </div>

      <div className="w-2/3 flex flex-col items-center p-md">
        <h2 className="text-xl font-semibold mb-xs">Generated Mind Map</h2>
        {
          <MindMapCourse
            mindMap={mindMap}
            loading={loading}
            fullScreenMode={fullScreenMode}
            onFullScreen={() => setFullScreenMode(!fullScreenMode)}
          />
        }
      </div>
    </div>
  );
};
